import { FC, useEffect, useState } from 'react';
import { Button } from 'antd';
import { TbQuestionMark } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { HelpButtonDropdown } from '@/shared';

const SmallHelpButton: FC = (): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { token } = useAntDesignTheme();

    return (
        <>
            <HelpButtonDropdown>
                <Button
                    size='small'
                    icon={
                        <TbQuestionMark
                            style={{
                                color: token.colorTextTertiary,
                            }}
                        />
                    }
                    type={'text'}
                />
            </HelpButtonDropdown>
        </>
    );
};

export default SmallHelpButton;
